
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewind/expired",
      function () {
        return require("private-next-pages/rewind/expired.tsx");
      }
    ]);
  